import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {BillingService} from '../../service/billing/billingService.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ReferenceCompanyGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var referenceCompanyGrid = this;
		setTimeout(function(){
			referenceCompanyGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var referenceCompanyGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERENCE_COMPANY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERENCE_COMPANY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERENCE_COMPANY:UPDATE_STATUS'],
					style: 'float: right;',
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				}		
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'companyName',
					header: 'Company Name',					
					width: '7em'
				},
				{						
					path: 'generalPhone',
					header: 'Phone',					
					width: '7em'
				},				
				{						
					path: 'generalEmail',
					header: 'Email',					
					'flex-grow': '1'					
				},
				{						
					path: 'addressLine1',
					header: 'Address Line1',						
					width: '9em'
				},
				{						
					path: 'cityName',
					header: 'Cell Phone',					
					width: '7em'
				},				
				{						
					path: 'stateProvinceCode',
					header: 'State/Prov',					
					width: '7em'
				},				
				{						
					path: 'countryCode',
					header: 'Country',					
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'updateStatus').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					referenceCompanyGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						referenceCompanyGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getReferenceCompanyService().getReferenceCompanies(referenceCompanyGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'reference-companies',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'reference-companies.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		referenceCompanyGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Reference Company',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
													
							var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'companyName',
											required: true,
											maxlength: 255
										},	
										{
											tag: 'vaadin-text-field',
											label: 'Phone',
											name: 'generalPhone',											
											required: true,
											maxlength: 40
										},
										{
											tag: 'vaadin-text-field',
											label: 'Fax',
											name: 'generalFax',											
											maxlength: 40
										},
										{
											tag: 'vaadin-text-field',
											label: 'Email',
											name: 'generalEmail',											
											maxlength: 255
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'vaadin-text-field',
											label: 'Address',
											name: 'addressLine1',	
											required: true,
											maxlength: 120
										},										
										{
											tag: 'vaadin-text-field',
											label: 'Postal Code',
											name: 'postalCode',
											required: true,
											maxlength: 40
										},
										{
											tag: 'vaadin-text-field',
											label: 'City',
											name: 'cityName',
											required: true,
											maxlength: 80
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'state',
											label: 'State/Providence', 
											name: 'stateProvinceCode',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'vaadin-text-field',
											label: 'Primary Contact First Name',
											name: 'primaryContactFirstName',
											required: true,
											maxlength: 80
										},
										{
											tag: 'vaadin-text-field',
											label: 'Primary Contact Last Name',
											name: 'primaryContactLastName',
											required: true,
											maxlength: 80
										},
										{
											tag: 'vaadin-text-field',
											label: 'Primary Contact Job Title',
											name: 'primaryContactJobTitle',
											required: true,
											maxlength: 80
										},
										{
											tag: 'vaadin-text-field',
											label: 'Primary Contact Phone',
											name: 'primaryContactPhone',
											required: true,
											maxlength: 40
										},
										{
											tag: 'vaadin-text-field',
											label: 'Primary Contact Email',
											name: 'primaryContactEmail',
											required: true,
											maxlength: 255
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'vaadin-number-field',
											label: 'Max Ref Count',
											name: 'maxRefCount',											
											max: 9999,
											value: 100,
											min: 0	
										},
										{
											tag: 'vaadin-number-field',
											label: 'Max Program Count',
											name: 'maxPgmCount',											
											max: 9999,
											value: 100,
											min: 0	
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																	data.countryCode = ElementUtil.query(formPanel, 'state').selectedItem.country;
																	if (record) {
																		data.refCompanyId = record.refCompanyId;
																	}
																	return data;
																},
																actualCall: function(data) {
																	return BillingService.getReferenceCompanyService().saveRefCompany(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Reference Company', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							formPanel.load(record);							
						}
					}
				}
			});
		
						
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'A') {
				BillingService.getReferenceCompanyService().updateRefCompanyStatus(record.refCompanyId, false).then(function(){
					loadMask.remove();				
					actionRefresh();
				});	
			} else {
				BillingService.getReferenceCompanyService().updateRefCompanyStatus(record.refCompanyId, true).then(function(){
					loadMask.remove();				
					actionRefresh();
				});
			}
		};		
	

	}
	
};
customElements.define('dl-reference-company-grid', ReferenceCompanyGrid);
